export default __webpack_public_path__ + "static/media/Resume1.920ac7f7.pdf";